export default "__VITE_ASSET__2wEWwlfM__"